import { render } from "./YangiliklarElonlar.vue?vue&type=template&id=a5568dba"
import script from "./YangiliklarElonlar.vue?vue&type=script&lang=js"
export * from "./YangiliklarElonlar.vue?vue&type=script&lang=js"

import "./YangiliklarElonlar.vue?vue&type=style&index=0&id=a5568dba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__